import React from 'react';
import styled from '@emotion/styled';
import { Color, FontSize } from 'views/constants';

const LabelWrapper = styled.div`
  padding-right: 16px;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
`;

interface WithLabelProps {
  label: React.ReactNode;
}

const WithLabel: React.FC<WithLabelProps> = ({ label, children }) => (
  <InputWrapper>
    <LabelWrapper>{label}</LabelWrapper>
    {children}
  </InputWrapper>
);

const StyledInputText = styled.input`
  flex: 1;
  width: 100%;
  padding: 0;
  border: 1px solid ${Color.C14};
  border-radius: 3px;
  padding: 6px;
  box-sizing: border-box;
  font-size: ${FontSize.DEFAULT};
  font-weight: bold;
  color: ${Color.C1};

  &::-webkit-input-placeholder {
    color: ${Color.C14};
    font-size: ${FontSize.S};
  }

  &:disabled {
    font-weight: normal;
    color: ${Color.C2};
  }
  &:disabled::-webkit-input-placeholder {
    color: ${Color.C2};
  }
`;

interface InputTextProps {
  id?: string;
  type?: 'text' | 'email' | 'password';
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  label?: React.ReactNode;
  defaultValue?: string;
  onChange?(value: string): void;
  autoFocus?: boolean;
}

export const InputText: React.FC<InputTextProps> = ({
  id,
  type,
  placeholder,
  disabled,
  required,
  label,
  defaultValue,
  onChange,
  autoFocus,
}) => {
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    if (onChange) {
      onChange(event.target.value);
    }
  };
  const InputTextElement = (
    <StyledInputText
      id={id}
      type={type}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      defaultValue={defaultValue}
      onChange={handleOnChange}
      autoFocus={autoFocus}
    />
  );
  return label ? (
    <WithLabel label={label}>{InputTextElement}</WithLabel>
  ) : (
    InputTextElement
  );
};

InputText.defaultProps = {
  type: 'text',
};
